// MENFOOTWEAR
export const GET_MENFOOTWEAR_REQUEST = "GET_MENFOOTWEAR_REQUEST";
export const GET_MENFOOTWEAR_SUCCESS = "GET_MENFOOTWEAR_SUCCESS";
export const GET_MENFOOTWEAR_FAILURE = "GET_MENFOOTWEAR_FAILURE";

// menClothing

export const GET_MENCLOTHING_REQUEST = "GET_MENCLOTHING_REQUEST";
export const GET_MENCLOTHING_SUCCESS = "GET_MENCLOTHING_SUCCESS";
export const GET_MENCLOTHING_FAILURE = "GET_MENCLOTHING_FAILURE";
// menAccessories

export const GET_MENACCESSORIES_REQUEST = "GET_MENACCESSORIES_REQUEST";
export const GET_MENACCESSORIES_SUCCESS = "GET_MENACCESSORIES_SUCCESS";
export const GET_MENACCESSORIES_FAILURE = "GET_MENACCESSORIES_FAILURE";
